var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card mx-md-5 mt-3 mb-3 bg-form"},[_c('card-header',{attrs:{"title":_vm.getTitle,"iconName":'folder2-open'}}),_c('b-card-body',[_c('Announcement',{attrs:{"activity":_vm.activity}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }